@if (facade.active()) {
<div class="impersonation-notch" [class.warning]="facade.warning()">
    <span class="notch-icon">⚠</span>
    <span class="notch-email">{{ facade.impersonatorEmail() }}</span>
    <span class="notch-separator">·</span>
    <span class="notch-label">{{ 'app.impersonation.label' | translate }}</span>
    <span class="notch-separator">·</span>
    <span class="notch-counter">{{ facade.counterLabel() }}</span>
</div>
}
